import type { ReactNode } from 'react';
import { WL_PING, WL_PONG } from '../tokens';
import { WebSocketClientProvider } from './WebSocketClientProvider';

/**
 * Wraps the WebSocketClientProvider with the ping and pong types for the whitelabel.
 */
export function WLWebSocketClientProvider({ children }: { children: ReactNode }) {
  return <WebSocketClientProvider children={children} pingPongTypes={{ ping: WL_PING, pong: WL_PONG }} />;
}
